var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout l-default", class: _vm.classes },
    [
      !_vm.noHeader ? _c("k-site-header") : _vm._e(),
      _vm._t("default"),
      _c("k-nav-main", {
        attrs: { menu: _vm.menu, logo: _vm.site.logo, title: _vm.site.title },
      }),
      !_vm.noFooter ? _c("wp-footer") : _vm._e(),
      _c("overlay"),
      _c("sidebar", { attrs: { pos: "left" } }),
      _c("sidebar", { attrs: { pos: "right" } }),
      _c("modal"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }